import React, { useEffect } from "react";
import "./Advantage2.css";
import num2dark from "../images/num2-dark.png";

const Advantage2 = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = document.querySelectorAll(".advantage2-1 .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="advantage2-1">
      <div className="advantage2-2">
        <div className="img2-1 animate-side slide-right">
          <div
            className="logo-light"
            style={{
              backgroundImage: `url(${num2dark})`,
            }}
          />
        </div>
        <div className="advantage2-content animate-side slide-left">
          <h1>Streamlined Operations & Efficiency</h1>
          <div className="advantage2-3">
            <p>
              <label>Automated Workflows:</label>
              Eliminate repetitive manual tasks like paper receipt tracking, stock audits, and multi-platform inventory adjustments.<br/>
              <label>Real-Time Analytics:</label>
              Instantly monitor sales metrics, stock levels, and staff performance from any device, anywhere.<br/>
              <label>Error Reduction:</label>
              Direct communication between digital menus, KDS pipelines, and back-office ERP prevents lost orders and speeds up fulfillment.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Advantage2;